<template>
  <div id="zippidy">
    <v-progress-circular v-if="zipLoading" class="mt-5" :size="40" color="primary" indeterminate></v-progress-circular>
    <div v-else-if="zip.list.length" class="row pt-4 justify-content-between">
      <h4 class="mb-3 col-12 center">{{ listTitle }}</h4>      
      <code-listing lockAxis="y" v-model="zip.list" class="order-2 order-lg-1 col-12 col-lg-8">
        <!-- toggle all/none -->
        <div class="pl-3 pb-2">
          <v-checkbox
            color="grey darken-2"
            v-model="checkboxToggleAll"
            :label="checkboxToggleAll ? 'Deselect all' : 'Select all'"
          ></v-checkbox>
        </div>
        <code-listing-item
          v-for="(file, index) in zipListing"
          @select="setSelected($event)"
          :index="index"
          :key="file.path + file.id"
          :file="file"
          :toggleSelected="checkboxToggleAll"
        />
      </code-listing>
      <v-btn
        class="order-1 order-lg-2 mx-auto"
        color="primary"
        @click="addSelectedToMarkdown"
      >{{ $store.state.user.langEng ? 'Add code' : 'Lägg till kod' }}</v-btn>
    </div>
    <div v-show="(!zipLoading && zip.list.length === 0)">
      <small
        class="mt-3 text-left d-block"
      >{{ $store.state.user.langEng ? 'You can also paste the link of a particular github-branch.' : 'Du kan även klistra in länken till en specifik branch.' }}</small>
      <v-text-field
        class="input-github-repo mb-3"
        id="input-github-repo"
        v-model="githubRepo"
        color="teal"
        placeholder="GitHub Repo url"
        solo
        autocomplete="off"
        @keyup.enter="listGithubCode"
        append-icon="search"
        @click:append="listGithubCode"
      ></v-text-field>
      <div class="row">
        <file-upload class="col-12 col-lg-6 mb-3" />
        <stored-files
          class="col-12 col-lg-6"
          type="uploads"
          @zipFileList="loadZipFileList($event)"
          @selectedFilePath="setFilePath($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import FileUpload from "./FileUpload";
import StoredFiles from "./StoredFiles";
import CodeListing from "./CodeListing";
import CodeListingItem from "./CodeListingItem";
import { eventBus } from "@/main";
import { Api } from "@/utils";

@Component({
  components: {
    FileUpload,
    StoredFiles,
    CodeListing,
    CodeListingItem
  }
})
export default class CodeFromZip extends Vue {
  githubRepo = "";
  zip = { list: [] };
  zipFiles = [];
  selected = [];
  pathToZip = "";
  zipLoading = false;
  
  checkboxToggleAll = true;

  get modifiedGitHubRepoLink() {
    let s = this.githubRepo;
    if (!s.endsWith('.zip')) {
      if (s.includes('/tree/')) {
        s = s.replace('/tree/', '/archive/');
      } else {
        s += "/archive/master";
      }

      s += '.zip'
    }
    return s;
  }

  async addSelectedToMarkdown() {
    const selected = this.selected.slice();
    const dlButton = this.pathToZip
      ? this.pathToZip
      : this.modifiedGitHubRepoLink;
    const path = dlButton.replace("/uploads/zips", "");
    const order = this.zip.list
      .filter(z => selected.includes(z))
      .map(s => s.id);
    const files = await Api.get(`listzip/all/${path}?only=${order.join(",")}`);
    // $on CreateArticleTextarea.vue
    eventBus.$emit("selectedListing", { dlButton, order, files });
    if (this.zipFiles.length) {
      const nextFile = this.zipFiles.shift();
      this.setFilePath(nextFile.file);
      this.zip.list = [];
      this.zip.file = '';
      if (!nextFile.list.length) {
        this.addSelectedToMarkdown();
      } else {
        setTimeout(() => {
          this.zip.list = nextFile.list;
          this.zip.file = nextFile.file;
        }, 1);
      }
    } else {
      this.$store.commit('setCurrentContentArea', 'TextArea');
      this.zip.list = [];
      this.zip.file = '';
      this.$store.commit('resetZipFiles');
    }
  }

  get zipListing() {
    return this.zip.list.filter(
      z => !z.path.includes("node_modules") && !z.path.includes(".idea")
    );
  }

  get listTitle() {
    return this.githubRepo
      ? this.modifiedGitHubRepoLink.replace(/^https:\/\/|^http:\/\//, "")
      : this.pathToZip.replace(/\/.*\/.*\//, "");
  }

  listGithubCode() {
    // $on StoredFiles.vue
    eventBus.$emit("listGithubCode", this.modifiedGitHubRepoLink);
  }

  setFilePath(path) {
    this.pathToZip = path;
  }

  setSelected(data) {
    if (data.event === "add") {
      this.selected.push(data.file);
    } else if (data.event === "remove")
      this.selected.splice(this.selected.indexOf(data.file), 1);
  }

  loadZipFileList(zipFile) {
    if (!this.zip.file) {
      this.zip = zipFile;
      this.setFilePath(zipFile.file);
      if (!zipFile.list.length) {
        setTimeout(() => {
          this.addSelectedToMarkdown();
        }, 50);
      }
    } else {
      this.zipFiles.push(zipFile);
    }
  }

  created() {
    eventBus.$on("loadingZip", loading => (this.zipLoading = loading));
  }

  beforeDestroy() {
    eventBus.$off("loadingZip");
  }
}
</script>

<style scoped lang="scss">
#zippidy {
  animation-duration: 150ms;
}
</style>
